import { quoteActions } from '../constants/registry/quotes-table.constant';
import {
  DynamicTableBreakpoints,
  DynamicTableConfig,
} from '../interfaces/dynamic-table.interface';
import { compact, defaults } from 'lodash';
import { Quote, QUOTE_PERMISSIONS } from '@lockton-apps/shared/interfaces';
import { hasPermission } from '@lockton-apps/shared/util/helpers';

export const accaDashboardQuotesTablePreset: Partial<DynamicTableConfig> = {
  columns: [
    {
      id: 'title',
    },
    {
      id: 'renewalDate',
      layout: {
        [DynamicTableBreakpoints.DEFAULT]: {
          flex: '0 0 50%',
          order: 3,
        },
        [DynamicTableBreakpoints.SM]: {
          flex: 2,
          order: 2,
        },
      },
    },
    {
      id: 'assignedBroker',
      layout: {
        [DynamicTableBreakpoints.DEFAULT]: {
          flex: '0 0 50%',
          order: 4,
        },
        [DynamicTableBreakpoints.SM]: {
          flex: 2,
          order: 3,
        },
      },
    },
    {
      id: 'additionalRequests',
      layout: {
        [DynamicTableBreakpoints.DEFAULT]: {
          flex: '0 0 50%',
          order: 5,
        },
        [DynamicTableBreakpoints.SM]: {
          flex: 1,
          order: 4,
        },
      },
    },
    {
      id: 'workflowStatus',
      layout: {
        [DynamicTableBreakpoints.DEFAULT]: {
          flex: '0 0 50%',
          order: 6,
        },
        [DynamicTableBreakpoints.SM]: {
          flex: 1,
          order: 5,
        },
      },
    },
    {
      id: 'lastActivity',
      layout: {
        [DynamicTableBreakpoints.DEFAULT]: {
          flex: '0 0 50%',
          order: 7,
        },
        [DynamicTableBreakpoints.SM]: {
          flex: 2,
          order: 5,
        },
      },
    },
    {
      id: 'contextMenu',
      props: {
        actions: [
          quoteActions['viewStatus'],
          quoteActions['assignToBroker'],
          quoteActions['viewProposal'],
          defaults(
            {
              hidden: (entity: Quote) =>
                !hasPermission(entity, QUOTE_PERMISSIONS.canReturnProposal),
            },
            quoteActions['returnProposal']
          ),
          quoteActions['configureRenewal'],
        ],
      },
    },
  ],
};

export const accaQuotesTablePreset: Partial<DynamicTableConfig> = {
  columns: compact([
    { id: 'title' },
    {
      id: 'renewalDate',
      layout: {
        [DynamicTableBreakpoints.DEFAULT]: {
          flex: '0 0 50%',
          order: 3,
        },
        [DynamicTableBreakpoints.SM]: {
          flex: 2,
          order: 2,
        },
      },
    },
    {
      id: 'assignedBroker',
      layout: {
        [DynamicTableBreakpoints.DEFAULT]: {
          flex: '0 0 50%',
          order: 4,
        },
        [DynamicTableBreakpoints.SM]: {
          flex: 2,
          order: 3,
        },
      },
    },
    {
      id: 'assignedContacts',
      layout: {
        [DynamicTableBreakpoints.DEFAULT]: {
          flex: '0 0 50%',
          order: 5,
        },
        [DynamicTableBreakpoints.SM]: {
          flex: 2,
          order: 4,
        },
      },
    },
    {
      id: 'additionalRequests',
      layout: {
        [DynamicTableBreakpoints.DEFAULT]: {
          flex: '0 0 50%',
          order: 6,
        },
        [DynamicTableBreakpoints.SM]: {
          flex: 1,
          order: 5,
        },
      },
    },
    {
      id: 'workflowStatus',
      layout: {
        [DynamicTableBreakpoints.DEFAULT]: {
          flex: '0 0 50%',
          order: 7,
        },
        [DynamicTableBreakpoints.SM]: {
          flex: 1,
          order: 6,
        },
      },
    },
    {
      id: 'lastActivity',
      layout: {
        [DynamicTableBreakpoints.DEFAULT]: {
          flex: '0 0 50%',
          order: 8,
        },
        [DynamicTableBreakpoints.SM]: {
          flex: 2,
          order: 7,
        },
      },
    },
    {
      id: 'contextMenu',
      props: {
        actions: compact([
          quoteActions['viewStatus'],
          quoteActions['assignToBroker'],
          quoteActions['viewProposal'],
          quoteActions['assignContact'],
          defaults(
            {
              hidden: (entity: Quote) =>
                !hasPermission(entity, QUOTE_PERMISSIONS.canReturnProposal),
            },
            quoteActions['returnProposal']
          ),
          quoteActions['configureRenewal'],
        ]),
      },
    },
  ]),
};
